import React, { useRef, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoCamera } from "@fortawesome/free-solid-svg-icons";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { useLocation } from "react-router-dom";

import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { categories } from "../../helpers/mock-data";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { updateTutorialById } from "../../services/documents/documents.context";



export const UpdateTutorial = () => {

    const { token } = useAuth();

    const fileButton = useRef();

    const [onAlert, setOnAlert] = useState();

    const tutorial = useLocation()?.state?.tutorial;


    const [inputData, setInputData] = useState({
        document: null,
        title: tutorial?.title,
        field: tutorial?.field,
        oldFile: null
    });

    const [prevName, setPrevName] = useState(null);

    const [loading, setLoading] = useState(false);


    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = () => {
        const { title, field } = inputData;
        return isNull(title) || isNull(field);
    }

    const handleFileInput = (e) => {

        e.preventDefault();
        let fileType = e.target.files[0].type.split("/")[1];

        if (fileType !== "pdf") {
            setOnAlert({
                caption: "Error!",
                message: `Invalid file of type ${fileType}! Please upload a file of type pdf`,
                acceptAction: () => setOnAlert(),
                accept: "Ok"
            });
            return;
        }
        const uploadedFile = e.target.files[0];
        const fileName = uploadedFile.name;
        setPrevName(fileName);
        setInputData((data) => (
            { ...data, document: e.target.files[0] }
        ))
        setInputData((data) => ({ ...data, oldFile: tutorial?.pdfFile }))

    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (inputRequired()) {
            setOnAlert({
                caption: "Error!",
                message: "Please provide all the required data",
                accept: "Ok",
                acceptAction: () => setOnAlert()
            });

            return;
        }
        //console.log(token, inputData, tutorial?._id);
        setLoading(true);
        const resp = await updateTutorialById(token, inputData, tutorial?._id);
        console.log(resp);
        if (resp?.error) {
            setOnAlert({
                caption: "Error",
                message: resp?.error,
                accept: "Ok",
                acceptAction: () => {
                    setOnAlert();
                }
            })
            setLoading(false);
            return;
        }else{

        }
        setLoading(false);
        setOnAlert({
            caption: "Success",
            message: resp?.message,
            accept: "Ok",
            acceptAction: () => {
                setOnAlert();
            }
        })
        

    }



    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={`Update ${tutorial?.title}`} />
            {(loading) && <Loader />}
            {onAlert &&
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    close={() => setOnAlert()}
                    accept={onAlert.accept}
                    acceptAction={onAlert.acceptAction}
                />
            }
            <div className="form-container">
                <div className="input-container">
                    <span className="input-cap">
                        Title
                        <span className="req-asterix">*</span>
                    </span>

                    <input
                        type="text"
                        placeholder="Enter tutorial title"
                        className="input"
                        onChange={(e) => setInputData((data) =>
                            ({ ...data, title: e.target.value })
                        )}
                        value={inputData.title}
                    />
                </div>
                <div className="input-container">
                    <span className="input-cap">
                        Field of study
                        <span className="req-asterix">*</span>
                    </span>
                    <select
                        type="text"
                        name="category"
                        id="category"
                        className={classNames("input", "category")}
                        required
                        onChange={(e) => setInputData((data) => (
                            { ...data, field: e.target.value }
                        ))}
                        value={inputData?.field}
                    >
                        <option value={''}>
                            ---Choose subject area---
                        </option>
                        {categories.map((category, i) => (
                            <option value={category} key={i} >{category}</option>
                        ))}
                    </select>
                </div>
                <div className="file-btn-container">
                    <input
                        type="file"
                        className="file-button"
                        ref={fileButton}
                        onChange={(e) => { handleFileInput(e) }}
                    />
                    <button
                        onClick={() => fileButton.current.click()}
                        className="file-click"
                    >
                        <FontAwesomeIcon icon={faVideoCamera} style={{ marginRight: 8 }} />
                        Upload file
                    </button>
                </div>

                {prevName && (
                    <div className={classNames("prev")}>
                        <FontAwesomeIcon icon={faFilePdf} />
                        {prevName}
                    </div>)
                }

                <button
                    className="form-button"
                    onClick={async (e) => { await handleSubmit(e) }}
                >
                    Upload Tutorial
                </button>
            </div>
        </div>
    );
}